import React, { useEffect, useState } from 'react'
import { DataTable } from 'primereact/datatable'
import { enums } from '../../../constants'
import utils from '../../../utils/index'
import { Card } from 'primereact/card'
import { TabPanel, TabView } from 'primereact/tabview'
import _ from 'lodash'
import { Accordion, AccordionTab } from 'primereact/accordion'
import { InputTextarea } from 'primereact/inputtextarea'

export const ConsultaRemessaForm = (props) => {
  const record = props.record
  let identificacao = record.identificacao
  const itens = _.get(record, 'itens', [])
  const logs = _.get(record, 'logs', [])
  // Os filtros da tabela de itens são locais do DataTable: ele repagina, mas itens.length continua
  // sendo a remessa inteira. A contagem filtrada chega por onValueChange; null = sem filtro aplicado.
  // O TabView só mantém montada a aba aberta: ir para Logs desmonta a tabela e descarta os filtros
  // dela, então a contagem também volta a null na troca de aba.
  const [totalItensFiltrados, setTotalItensFiltrados] = useState(null)

  useEffect(() => {
    setTotalItensFiltrados(null)
  }, [itens, props.state.activeIndex])

  function getDadosGerais() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <DataTable
            selection={props.selection}
            onSelectionChange={props.onSelectionChange}
            reorderableColumns={true}
            resizableColumns={true}
            columnResizeMode="expand"
            filterDisplay="row"
            ref={props.dataTableItens}
            paginator={true}
            emptyMessage=" "
            rows={15}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={itens}
            onRowSelect={props.onRowSelect}
            onValueChange={(filtrados) => setTotalItensFiltrados(filtrados.length)}
            totalRecords={itens.length}
          >
            {props.colunasItens}
          </DataTable>
          <br />
          <div style={{ textAlign: 'right', margin: '7px' }}>
            <strong>Total: </strong> {totalItensFiltrados ?? itens.length}
          </div>
        </div>
      </div>
    )
  }
  function getDadosLogs() {
    return (
      <div className="p-grid p-fluid">
        <div className="p-col-12">
          <DataTable
            resizableColumns={true}
            columnResizeMode="expand"
            ref={props.dataTableLogs}
            paginator={true}
            emptyMessage="  "
            rows={15}
            rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
            value={logs}
            totalRecords={logs.length}
          >
            {props.colunasLogs}
          </DataTable>
        </div>
      </div>
    )
  }
  function getContent() {
    return (
      <>
        <Accordion>
          <AccordionTab header={utils.getMessage(props.messages, 'consultaremessa.label.filtros')}>
            <div className="p-grid p-fluid">
              <div className="p-col-12"></div>
              <InputTextarea
                value={record.parametros}
                name="parametros"
                rows={1}
                cols={100}
                autoResize={true}
                style={{ marginBottom: '10px;' }}
              />
            </div>
          </AccordionTab>
        </Accordion>
        <br />
        <TabView activeIndex={props.state.activeIndex} onTabChange={(e) => props.changeActiveIndex(e.index)}>
          <TabPanel header={utils.getMessage(props.messages, 'consultaremessa.label.dadosgerais')}>
            {getDadosGerais()}
          </TabPanel>
          <TabPanel header={utils.getMessage(props.messages, 'consultaremessa.label.logs')}>{getDadosLogs()}</TabPanel>
        </TabView>
      </>
    )
  }

  return (
    <div className="p-grid p-fluid">
      <div className="p-col-12">
        <Card
          title={`${utils.getMessage(props.messages, 'consultaremessa.label.consultaRemessas')} ${record.oid || ''}`}
          subTitle={identificacao || ''}
        >
          {getContent()}
        </Card>
      </div>
    </div>
  )
}
